export const GoogleMapApiConfig = 'AIzaSyAlVeRT8hQ8rxWrUJ11B18ImVWFW5CxWKk';